import { Component, Input } from '@angular/core';
import { HeadingBlock } from 'src/app/core/models/message-blocks';
import { MessageBlockBaseDirective } from '../../message-block-base.directive';

@Component({
  selector: 'app-mr-heading',
  templateUrl: './mr-heading.component.html',
  styleUrls: ['./mr-heading.component.scss'],
})
export class MrHeadingComponent extends MessageBlockBaseDirective {
  @Input() block!: HeadingBlock;
}
